<script>
import Layout from '@layouts/main';
import CompanyForm from '@views/companies/form';

export default {
  components: {
    Layout,
    CompanyForm,
  },
  page() {
    return {
      title: this.$t('titles.create_company'),
    };
  },
  data() {
    return {
      breadcrumbItems: [
        {
          text: this.$t('titles.home'),
          to: { name: 'home.index' },
        },
        {
          text: this.$t('titles.companies'),
          to: { name: 'companies.index' },
        },
        {
          text: this.$t('titles.create_company'),
          active: true,
        },
      ],
    };
  },
  methods: {
    create() {
      this.$router.push({
        name: 'companies.index',
      });
    },
  },
};
</script>

<template>
  <Layout>
    <b-breadcrumb :items="breadcrumbItems" />
    <b-card
      :border-variant="!errors.items.length ? 'dark' : 'danger'"
      :header="$t('titles.create_company')"
      header-tag="header"
      :header-bg-variant="!errors.items.length ? 'dark' : 'danger'"
      header-text-variant="white"
      class="mb-3"
    >
      <CompanyForm @submitted="create" />
    </b-card>
  </Layout>
</template>
